import { Grid } from '@mui/material';
import React from 'react';

const HomeCarousel = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <h1>Carousel</h1>
      </Grid>
    </Grid>
  );
};

export default HomeCarousel;
